import { createFileRoute } from "@tanstack/react-router";
import Article from "@/pages/Article";
import { buildArticleHead } from "@/data/seo";

export const Route = createFileRoute("/kundreferenser/$slug")({
  head: ({ params }) => buildArticleHead(params.slug, "referenser"),
  component: () => <Article category="referenser" />,
});
